import { useQuery } from '@tanstack/react-query'
import { NewsUpdatesApiResponse } from 'src/model/NewsUpdatesApiResponse'

import { fetchNews } from '../api/fetchers/fetchNews'

export const useNewsUpdates = (params: any) => {
  return useQuery<NewsUpdatesApiResponse[]>({
    queryKey: ['newsUpdate', params],
    queryFn: async ({ signal }) => {
      const res = await fetchNews(params)(signal)
      return res.data
    },
  })
}
